import {useState, useEffect} from 'react'
import Card from './Card';

const Author = ({language, author, itemHandler}) => {
    const [subjects, setSubjects] = useState([])
    const [loading, setLoading] = useState(true)
    
    const getSubjects = async (language, author) => {
        setLoading(true)
        const token = localStorage.getItem("token");
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/subjects/list-books?language=${language}&author=${author}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        });
        
        if (response.ok) {
            const json = await response.json();
            setSubjects(json)
        }
        setLoading(false)
    }

    useEffect(() => { getSubjects(language, author) }, [language, author])

    if (loading) {
        return (
            <div className="w-full">
                <div className='border-b border-gray-200 pb-1 mb-2'>
                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                </div>
                <div className='flex flex-wrap gap-2 justify-center'>
                    <div className="h-32 w-24 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>
        )
    }

    return (
        <div className="w-full">
            <div className='border-b border-gray-200 pb-1 mb-2'>
                <h3 className='text-sm font-semibold text-gray-800 text-center truncate' title={author}>{author}</h3>
            </div>
            <div className='flex flex-wrap gap-2 justify-center'>
                {subjects && subjects.map((item, i) => (
                    <Card key={item.userid+item.title+item.author+i} 
                          course={item} 
                          courseHandler={(state) => itemHandler(state)}/>
                ))}
            </div> 
        </div>
    )
}

export default Author;